import { Box, Button, Typography, styled } from '@mui/material';

const selectedContainerStyles = {
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: '#FFFFFF59',
	backgroundColor: '#FFFFFF1A',
};

export const PaymentContainer = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
});

export const BuyButton = styled(Button)({
	borderColor: '#FFFFFF59',
	backgroundColor: '#FFFFFF1A',
	borderRadius: '40px',
});

export const PaymentButtonContainer = styled(Box)({
	...selectedContainerStyles,
	display: 'flex',
	alignItems: 'center',
	gap: '6px',
	padding: '4px 8px',
	borderRadius: '40px',
});

export const PaymentText = styled(Typography)({
	color: '#FFFFFF',
	fontSize: '0.9em',
});

export const ProfileInfoText = styled(Typography)({
	textAlign: 'center',
	color: '#FFFFFF',
	fontSize: '0.8em',
});

export const SidebarItemsList = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '12px',
});

export const SidebarItemContainer = styled(Box)<{ selected: boolean; disabled?: boolean }>(
	({ selected, disabled = false }) => ({
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '80%',
		gap: '8px',
		padding: '8px',
		borderRadius: '8px',
		cursor: disabled ? 'default' : 'pointer',

		...(selected ? selectedContainerStyles : {}),
	})
);

export const SidebarItemText = styled(Typography)({
	color: '#FFFFFF',
	fontSize: '0.8em',
	letterSpacing: '0.4px',
});
